import { render, staticRenderFns } from "./TableBudgetStaffReady.vue?vue&type=template&id=219d095a&"
import script from "./TableBudgetStaffReady.vue?vue&type=script&lang=ts&"
export * from "./TableBudgetStaffReady.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports